// SectionHeader — encabezado de pantalla del backoffice: TÍTULO + contadores (badges) a la
// izquierda, acciones (ej. "+ Nuevo") a la derecha. Reproduce el patrón de los mocks M6:
// título + "[N activos] · [N inactivos]". El separador doble "══" del ASCII se traduce a un borde
// inferior opcional (`divider`).
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Badge } from '@/kit';

export interface SectionHeaderCounter {
    label: string;
    variant?: string;
}

export interface SectionHeaderProps {
    title: string;
    counters?: SectionHeaderCounter[];
    actions?: ReactNode;
    /** Borde inferior (equivalente al separador "══" del mock). Default: false. */
    divider?: boolean;
    className?: string;
}

export function SectionHeader({
    title,
    counters,
    actions,
    divider = false,
    className,
}: SectionHeaderProps) {
    return (
        <header
            className={cn(
                'flex flex-wrap items-center justify-between gap-3',
                divider && 'border-b border-border pb-3',
                className,
            )}
        >
            <div className="flex items-center gap-3">
                <h1 className="text-lg font-bold tracking-tight">{title}</h1>
                {counters && counters.length > 0 ? (
                    <div className="flex items-center gap-1.5">
                        {counters.map((c) => (
                            <Badge key={c.label} variant={c.variant ?? 'secondary'}>
                                {c.label}
                            </Badge>
                        ))}
                    </div>
                ) : null}
            </div>
            {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </header>
    );
}
